(function($, duo, undefined) {

	"use strict";

	/**
	 * @class FileUpload
	 * will add extra markup around a file upload, so it can be styled
	 * NOTE: this will only work properly with a single drupal "managed file" upload
	 * (that uploads automatically after a file has been selected)
	 */
	class FileUpload {

		/**
		 * Creates an instance of FileUpload
		 * @param {string} fileuploadInputSelector css selector for a file upload input
		 */
		constructor({fileuploadInputSelector = '.file-upload'} = {}) {
			this.fileuploadInputSelector = fileuploadInputSelector;

			// setup:
			this._setup();
		} /* constructor */

		_setup() {
			$(document).find(this.fileuploadInputSelector).once().each(function(index, element) {
				const $fileUpload = $(element);
				if(!$fileUpload.hasClass('styled-file-upload')) {

					// add an extra class to the file upload input:
					$fileUpload.addClass('styled-file-upload__item');

					// put a wrapper around the file-upload:
					const $wrapper = $('<div class="styled-file-upload"></div>');
					$fileUpload.wrap($wrapper);

					// put a label-wrapper around the file-upload,
					// -> the user will click on this:
					const $labelwrapper = $('<label class="styled-file-upload__label"></label>');
					$fileUpload.wrap($labelwrapper);

					// add a "visual" label/button:
					$fileUpload.after(`<div class="styled-file-upload__visual"><div class="styled-file-upload__visual__button">${ Drupal.t(`Add file`) }</div><div class="styled-file-upload__visual__textinput-wrapper"><div class="styled-file-upload__visual__textinput"></div></div></div>`);

				}
			});
		} /* _setup */

	} /* FileUpload */

	duo.FileUpload = FileUpload;

})(jQuery, window.duo = window.duo || {});
